/** Notice shown to a normal account while production has no Smart Audit API (spec R4). */
export const IN_DEVELOPMENT_MESSAGE = 'Đang phát triển';

/** Mock mode (spec R5): the mock answers instead of the server. Read at call time. */
const isMockMode = (): boolean =>
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_SMART_AUDIT_MOCK === 'true';

/**
 * True when every account may use Smart Audit: `REACT_APP_SMART_AUDIT_FOR_ALL=true`, or mock mode, where
 * Playwright runs with FOR_ALL=false and must still see the module (spec R4, R5, ruling R-1).
 */
export const smartAuditOpenToAll = (): boolean => isMockMode() || process.env.REACT_APP_SMART_AUDIT_FOR_ALL === 'true';
